export const BUTTON_TYPES = {
    BUTTON: 'button',
    SUBMIT: 'submit',
};
